"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToFiveDecimal = void 0;
function fixPrecision(input) {
    const num = Number(input);
    if (Number.isNaN(num))
        return num;
    if (num < 0) {
        return -fixPrecision(Math.abs(num));
    }
    return parseFloat(num.toPrecision(12));
}
exports.default = fixPrecision;
function roundToFiveDecimal(input) {
    const num = Number(input);
    if (Number.isNaN(num))
        return num;
    if (num < 0) {
        return -roundToFiveDecimal(Math.abs(num));
    }
    // Use toFixed to avoid floating point issues, then convert back to number
    const rounded = Number(num.toFixed(5));
    // // Treat numbers very close to whole numbers as whole numbers
    // // e.g., 0.00001 -> 0, 0.99999 -> 1
    // const nearestInt = Math.round(rounded)
    // if (Math.abs(rounded - nearestInt) <= 0.00001) {
    //   return nearestInt
    // }
    return rounded;
}
exports.roundToFiveDecimal = roundToFiveDecimal;
//# sourceMappingURL=fixPrecision.js.map